import {
  Level_INFO_getInstance2sl9dbxnkg9gp as Level_INFO_getInstance,
  Level_ERROR_getInstancel7m27xkdxe0e as Level_ERROR_getInstance,
} from './Level.mjs';
import { toStringSafe207d7m7lap1sq as toStringSafe } from './internal/MessageInvoker.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function info(message) {
  return this.y2f(null, null, message);
}
function info_0(throwable, message) {
  return this.y2f(null, throwable, message);
}
function info_1(marker, throwable, message) {
  var tmp = Level_INFO_getInstance();
  return this.f2g(tmp, marker, ($this$at) => {
    $this$at.a2g_1 = toStringSafe(message);
    $this$at.b2g_1 = throwable;
    return Unit_instance;
  });
}
function error(throwable, message) {
  return this.h2g(null, throwable, message);
}
function error_0(marker, throwable, message) {
  var tmp = Level_ERROR_getInstance();
  return this.f2g(tmp, marker, ($this$at) => {
    $this$at.a2g_1 = toStringSafe(message);
    $this$at.b2g_1 = throwable;
    return Unit_instance;
  });
}
var KLoggerClass;
function KLogger() {
  if (KLoggerClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'KLogger');
    KLoggerClass = $;
  }
  return KLoggerClass;
}
//region block: exports
export {
  error as error12wpw0xi3o0bs,
  error_0 as error1aa4zvb3h0fa3,
  info_1 as info2wxw456lwpd2r,
  info_0 as info2hxv79dt541ps,
  info as info3uezdutu3rpr2,
  KLogger as KLogger368y32iihya1v,
};
//endregion

//# sourceMappingURL=KLogger.mjs.map
